module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-ni.cc1b6549.png";